export default {
    storageTokenKey: 'amw-jwt',
    storageRedirectUriKey: 'amw-login-origin',
    tokenQueryKey: 'token',
    loginUri: '/saml_login',
    refreshtokenUri: '/api/token/refresh',
    minTokenTime: 240 // minimum timeout to the next token refresh in minutes
  };
